var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 164,
    viewBox: "0 0 268 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.071 83L121.142 75.8845L114.071 68.7689",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    width: 94,
    height: 72.0667,
    rx: 8,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 0.5,
    width: 93,
    height: 71.0667,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.355,
    y: 8.35547,
    width: 77.2889,
    height: 55.3556,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.644 38.0644V60.711C224.644 62.3679 223.301 63.711 221.644 63.711H150.355C148.699 63.711 147.355 62.3679 147.355 60.711V55.5782L165 36L181.026 53.7829L210 22L224.644 38.0644Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.855,
    y: 8.85547,
    width: 76.2889,
    height: 54.3556,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 26,
    r: 6,
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 80,
    width: 94,
    height: 72.0667,
    rx: 8,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 80.5,
    width: 93,
    height: 71.0667,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.355,
    y: 88.3555,
    width: 77.2889,
    height: 55.3556,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.644 118.065V140.711C224.644 142.368 223.301 143.711 221.644 143.711H150.355C148.699 143.711 147.355 142.368 147.355 140.711V117.46L153 111L161.125 120.298L164.999 116L176.342 128.586L194 108L199.105 113.951L209.999 102L224.644 118.065Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.855,
    y: 88.8594,
    width: 76.2889,
    height: 54.3556,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 99L177.975 102.282L181.706 103.146L179.196 106.038L179.527 109.854L176 108.36L172.473 109.854L172.804 106.038L170.294 103.146L174.025 102.282L176 99Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 116,
    r: 9,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 36,
    r: 9,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 111,
    r: 7,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 31,
    r: 7,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 105,
    r: 12,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 25,
    r: 12,
    fill: "#0D5FDE",
    fillOpacity: 0.15,
    stroke: "#9656FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.284,
    y: 133.27,
    width: 12.7196,
    height: 30.8905,
    transform: "rotate(-45 209.284 133.27)",
    fill: "#729AD8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.7196,
    height: 1.81709,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 232.407 156.406)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.296 159.296C237.248 161.249 240.414 161.249 242.367 159.296L244.29 157.373C246.242 155.421 246.242 152.255 244.29 150.302L241.401 147.414L232.407 156.408L235.296 159.296Z",
    fill: "#42597D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.569,
    y: 120.43,
    width: 5.45126,
    height: 5.45126,
    rx: 1,
    transform: "rotate(-45 201.569 120.43)",
    fill: "#9656FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.139 123.001L207.994 119.146L218.273 124.285L209.279 133.28L204.139 123.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 72.0667,
    rx: 8,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 71.0667,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 8.35547,
    width: 77.2889,
    height: 55.3556,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6444 38.0644V60.711C85.6444 62.3679 84.3012 63.711 82.6444 63.711H11.3555C9.69862 63.711 8.35547 62.3679 8.35547 60.711V55.5782L25.9999 36L42.0264 53.7829L70.9999 22L85.6444 38.0644Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.85547,
    y: 8.85547,
    width: 76.2889,
    height: 54.3556,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 26,
    r: 6,
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 94,
    height: 72.0667,
    rx: 8,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 80.5,
    width: 93,
    height: 71.0667,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 88.3555,
    width: 77.2889,
    height: 55.3556,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6444 118.065V140.711C85.6444 142.368 84.3012 143.711 82.6444 143.711H11.3555C9.69862 143.711 8.35547 142.368 8.35547 140.711V117.46L14 111L22.1252 120.298L25.999 116L37.3418 128.586L55 108L60.1045 113.951L70.999 102L85.6444 118.065Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.85547,
    y: 88.8594,
    width: 76.2889,
    height: 54.3556,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 99L38.975 102.282L42.7063 103.146L40.1955 106.038L40.5267 109.854L37 108.36L33.4733 109.854L33.8045 106.038L31.2937 103.146L35.025 102.282L37 99Z",
    fill: "#A6A6A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowto);
export default __webpack_public_path__ + "static/media/howto.f4fba19c3d715958b1b4c6994c22cd8f.svg";
export { ForwardRef as ReactComponent };